export var config = {
  test: {
    authGateUrl: 'https://auth-gate.test.cheggnet.com/auth-gate/graphql',
    /* TODO update urls to be tld aware */
    jerichoUrl: 'https://trunk.live.test.cheggnet.com',
    mfaUrl: 'https://mfa.test.identity.chegg.services/graphql',
    newRelic: {
      key: 'NRII-NKhYYYt2U1KUxYFcGdb4NKCia61dtujg',
      id: '501278'
    },
    mx: {
      authGateUrl: 'https://auth-gate.test.cheggnet.com.mx/auth-gate/graphql',
      cookieDomain: '.test.cheggnet.com.mx'
    }
  },
  prod: {
    authGateUrl: 'https://gateway.chegg.com/auth-gate/',
    /* TODO update urls to be tld aware */
    jerichoUrl: 'https://www.chegg.com',
    mfaUrl: 'https://mfa.prod.identity.chegg.services/graphql',
    newRelic: {
      key: 'NRII-Mi0ZOVEe_ofN3PNkKFbYnXl2rhtskKKD',
      id: '501356'
    },
    mx: {
      authGateUrl: 'https://auth-gate.chegg.com.mx/auth-gate/graphql',
      cookieDomain: '.chegg.com.mx'
    }
  }
};
export var Environment = /*#__PURE__*/function (Environment) {
  Environment["test"] = "test";
  Environment["prod"] = "prod";
  return Environment;
}({});
var oneAuthEnv = Environment.test;
var cookieDomainUrl;
var clientId;
var resetPasswordRedirect = '';
var authGateUrl;
var useCheggMfa;
export function setClientId(id) {
  clientId = id;
}
export function getClientId() {
  return clientId;
}
export function getCookieDomain() {
  return cookieDomainUrl;
}
export function setCookieDomain(domain) {
  cookieDomainUrl = domain;
}
export function setEnv(newEnv) {
  oneAuthEnv = newEnv;
}
export function getEnv() {
  return oneAuthEnv;
}
export function setResetPasswordRedirect(url) {
  resetPasswordRedirect = url;
}
export function getResetPasswordRedirect() {
  return resetPasswordRedirect;
}
export function getAuthGateUrl() {
  if (authGateUrl) {
    return authGateUrl;
  }
  return config[oneAuthEnv].authGateUrl;
}
export function getMfaUrl() {
  return config[oneAuthEnv].mfaUrl;
}
export function setAuthGateUrl(url) {
  authGateUrl = url;
}
export function isAltAuthgateUrl() {
  return !!authGateUrl;
}
export function setUseCheggMfaToken(flag) {
  useCheggMfa = !!flag;
}
export function shouldUseCheggMfaToken() {
  return useCheggMfa;
}
export function setInternationalDomain(domain) {
  //@ts-ignore
  var internationalDomain = config[oneAuthEnv][domain];
  if (internationalDomain) {
    setCookieDomain(internationalDomain.cookieDomain);
    setAuthGateUrl(internationalDomain.authGateUrl);
  }
}